import styled from 'styled-components';

export default styled.div`
  height: 100%;
  width: 100%;
  background-image: linear-gradient(180deg, rgba(27, 27, 27, 0) 40.88%, rgba(4, 4, 4, 0.5) 72.93%),
    url(${(props: { imageUrl: string }) => props.imageUrl});
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: center;
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/HeroImageContainer.tsx